var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.728027,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 14.5613L16.4711 19.3241C17.0221 19.7098 17.2976 19.9027 17.5972 19.9774C17.8619 20.0433 18.1387 20.0433 18.4034 19.9774C18.7031 19.9027 18.9786 19.7098 19.5296 19.3241L26.3337 14.5613M13.667 25.3946H22.3337C23.7338 25.3946 24.4339 25.3946 24.9686 25.1221C25.439 24.8824 25.8215 24.5 26.0612 24.0296C26.3337 23.4948 26.3337 22.7947 26.3337 21.3946V16.0613C26.3337 14.6611 26.3337 13.9611 26.0612 13.4263C25.8215 12.9559 25.439 12.5734 24.9686 12.3338C24.4339 12.0613 23.7338 12.0613 22.3337 12.0613H13.667C12.2669 12.0613 11.5668 12.0613 11.032 12.3338C10.5616 12.5734 10.1792 12.9559 9.93948 13.4263C9.66699 13.9611 9.66699 14.6611 9.66699 16.0613V21.3946C9.66699 22.7947 9.66699 23.4948 9.93948 24.0296C10.1792 24.5 10.5616 24.8824 11.032 25.1221C11.5668 25.3946 12.2669 25.3946 13.667 25.3946Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2023822d44d5aa637de78d937e3b0838.svg";
export { ForwardRef as ReactComponent };